import React from 'react';
import { displayOptionRowContent } from 'modules/Layout/view/Details/Helper/DisplayContent';
import { getPathUrl } from 'modules/Shared/helper/api';
import { FeedbackEntity } from '../../../model/Feedback';
import { ROUTE_USER_DETAILS } from '../../../routes';
import ActionDelete from '../../../../Layout/component/Action/Delete';
import ActionUpdate from '../../../../Layout/component/Action/Update';

export interface Props {
  feedback: FeedbackEntity;
  onSetResponded: (responded: boolean) => Promise<void>;
}

const FeedbackDetails = (props: Props): JSX.Element => {
  const { feedback, onSetResponded } = props;

  const fields = [
    {
      title: 'User email:',
      description: feedback.email,
      to: getPathUrl(ROUTE_USER_DETAILS, { id: feedback.user_id }),
      type: 'link'
    },
    {
      title: 'Responded:',
      reactNode: (
        <div>
          {feedback.responded ? 'Yes' : 'No'}
          {feedback.responded ? (
            <ActionDelete
              label={<i className="fas font-22 fa-times ml-2" />}
              title="Set to not responded"
              onClick={() => onSetResponded(false)}
            />
          ) : (
            <ActionUpdate
              label={<i className="fas font-20 fa-check ml-2" />}
              title="Set to responded"
              onClick={() => onSetResponded(true)}
            />
          )}
        </div>
      )
    },
    {
      title: 'Sent at:',
      description: feedback.created_at
    },
    {
      title: 'Description:',
      description: feedback.description
    }
  ];

  return (
    <div>
      <div className="card">
        <div className="card-body p-3">
          <div className="d-flex">
            {Boolean(feedback.imageBase64) && (
              <div className="d-flex flex-column mr-5">
                <div className="mb-2 font-weight-bold font-20">
                  Image sent by user:
                </div>
                <img
                  style={{ maxWidth: 400 }}
                  alt="sent_image"
                  src={`data:image/png;base64,${feedback.imageBase64}`}
                />
              </div>
            )}
            <div className="flex-grow-1">{displayOptionRowContent(fields)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackDetails;
